
<template>
  <div id="cropme">
      <Menutop></Menutop>
      <div class="row container">
        <div class="col">

<h1>Cropme für Customer {{ customer }}</h1>
<div>
  <p>
    Zur Zeit gibt es {{ anzahl_vorgaenge() }} Vorgänge zu bearbeiten... TODO.
        
  </p>

  <ul>
    <li v-for="(vorgang,i) in vorgaenge" :key="`${i}`">
          <router-link :to="'/cropme/' + customer + '/vorgang/' + vorgang"><a>gehe zu {{ customer }}/vorgang/{{ vorgang }}</a></router-link>
        </li>
  </ul>

</div>

        </div>
      </div>
      <Footer></Footer>
  </div>
</template>

<script>
import Menutop from '../components/Menutop.vue';
import Footer from '../components/Footer.vue';
// kommt von pinegrow/bootstrap4:
import '../components/sticky-footer-navbar.css';
import axios from 'axios';

// Mixin fuer diese Komponente importieren
import loginzustand from './mixins/loginzustand.js';
import commonvars from './mixins/commonvars.js';

export default {
  name: 'Cropme',
  components: {
    Menutop,
    Footer
  },
  data() {
    return {
      customer: this.$route.params.customer,
      vorgaenge: [],
      anzahl_offene_vorgaenge: 0
    }
  },
  mounted: function() {
    this.api_loginzustand_feststellen();
    this.get_offene_vorgaenge_ids();
  },
  mixins: [
    loginzustand,
    commonvars
  ],
  methods: {
    anzahl_vorgaenge() {
      return this.vorgaenge.length;
    },
    offene_vorgaenge_fuer_customer_url() {
      return this.server_base_url()
      + "/api/vorgaenge/customer/"
      + this.customer
      + "/offen";
    },
    get_offene_vorgaenge_ids() {
      let url = this.offene_vorgaenge_fuer_customer_url();
      console.log(url);
      
      axios
        .get(url)
        .then(
          response => {
            console.log(response);
            this.vorgaenge = response.data.offene_vorgaenge;
            this.anzahl_offene_vorgaenge = response.data.anzahl_offene_vorgaenge;

            if (response.data.anzahl_offene_vorgaenge > 0) {
              let erster_offener_vorgang = response.data.offene_vorgaenge[0];
              console.log("Erster offener Vorgang ist " + erster_offener_vorgang);
              let neue_url = "/cropme/"
                  + this.customer
                  + "/vorgang/"
                  + erster_offener_vorgang;
              this.$router.push(neue_url);
            }
          }
      );
    }
  }
}

</script>

<style scoped>
img {
  max-width: 100%; /* ????? This rule is very important, please do not ignore this! */
}
</style>
